import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";

export const selectBranchModal = ({
  t,
  branches,
  selectLoginBranch,
  closeMsg,
  logoutAction,
}: stdObject) => {
  return {
    title: t("p.selectBranch"),
    mainColor: colors.blue,
    blocked: true,
    inputListStyle: { height: 300 },
    table: (branches || []).map((e: stdObject, index: number) => ({
      data: [e.NOMSUC],
      style: {
        textAlign: "center",
        backgroundColor: index % 2 === 0 ? colors.lightGrey : colors.white,
      },
      onClick: () => selectLoginBranch(e.CODSUC),
    })),
    buttons: [
      {
        label: t("p.cancel"),
        onClick: () => {
          logoutAction();
          closeMsg();
        },
        color: colors.darkGrey,
      },
    ],
  };
};
